import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskRovoServiceAgentRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-rovo-service-agent',
	path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent',
	exact: true,
};
